import { Crud, HttpClient, httpClient } from 'lib/HttpClient';

class LinksApi extends Crud {
    constructor(httpClient: HttpClient) {
        super(httpClient, import.meta.env.API_SERVER_URL, 'links');
    }
}

export const linksApi = new LinksApi(httpClient);
